import BaseRequestError from './routes/BaseRequestError';
import Callback from '@/modules/auth/_routes';
import Driver from '@/modules/driver/_routes';
import Drivers from '@/modules/drivers/_routes';
import Franchise from '@/modules/franchise/_routes';
import Franchises from '@/modules/franchises/_routes';
import FranchiseSummary from '@/modules/franchiseSummary/_routes';
import LogisticOperator from '@/modules/logisticOperator/_routes';
import LogisticOperators from '@/modules/logisticOperators/_routes';
import Orders from '@/modules/orders/_routes';
import Store from '@/modules/store/_routes';
import Stores from '@/modules/stores/_routes';
import CityShowcase from '@/modules/cityShowcase/_routes';
import Coupons from '@/modules/coupons/_routes';
import Coupon from '@/modules/coupon/_routes';
import CouponPackages from '@/modules/couponPackages/_routes';
import SubscriptionPlans from '@/modules/subscriptionPlans/_routes';
import FinancialStatus from '@/modules/financialStatus/_routes';
import Occurrences from '@/modules/occurrences/_routes';
import Occurrence from '@/modules/occurrence/_routes';
import UserSettings from '@/modules/userSettings/_routes';
import UserPassword from '@/modules/userPassword/_routes';
import Campaigns from '@/modules/campaigns/_routes';
import Campaign from '@/modules/campaign/_routes';
import CampaignBounds from '@/modules/campaignBounds/_routes';
import Notification from '@/modules/notification/_routes';
import Notifications from '@/modules/notifications/_routes';
import Deeplinks from '@/modules/deeplinks/_routes';
import External from './routes/External';

const [vocePedeRoute,] = External;

export default [
  /* public route */
  ...UserPassword,
  ...BaseRequestError,
  ...Callback,
  ...Franchises,
  ...Franchise,
  ...FranchiseSummary,
  ...LogisticOperators,
  ...LogisticOperator,
  ...Stores,
  ...Store,
  ...CityShowcase,
  vocePedeRoute,
  ...Drivers,
  ...Driver,
  ...Orders,
  ...Campaigns,
  ...Campaign,
  ...CampaignBounds,
  ...Coupons,
  ...Coupon,
  /* Much+ section: the anchor route needs to come before the tabs. */
  ...SubscriptionPlans,
  ...CouponPackages,
  ...Deeplinks,
  ...Notification,
  ...Notifications,
  ...FinancialStatus,
  ...Occurrences,
  ...Occurrence,
  ...UserSettings,
];
